<template>
  <v-snackbar
    :value="isDisplay"
    bottom
    right
  >
    {{ getMessage }}
    <v-btn
      color="success"
      flat
      @click.stop="setDisplay(false)"
    >
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      isDisplay: 'snackbar/isDisplay',
      getMessage: 'snackbar/getMessage'
    }),
    snackbar: {
      get () {
        return this.isDisplay
      },
      set (value) {
        this.setDisplay(value)
      }
    }
  },
  methods: {
    ...mapActions({
      setDisplay: 'snackbar/setDisplay'
    })
  }
}
</script>
